

export default function About () {
    return (
        <div>
            <h1>this is the about page</h1>
        </div>
    )
}